// @flow
import * as React from 'react';
import { LoadingButton } from '@mui/lab';
import { useAgent, useStartTestCallFor30SecondsMutation } from '../../../shared';

type Props = {
  clientId?: string,
};
export const TestCallButton = ({clientId}: Props) => {
  const [call, {loading}] = useStartTestCallFor30SecondsMutation();
  const agent = useAgent();

  return (
    <LoadingButton loading={loading} size={'small'} variant={'outlined'} color={'info'} onClick={() => {
      call({
        variables: {
          clientId, agentId: agent?.id,
        }
      })
    }}>
      Start Test Call
    </LoadingButton>
  );
};
